<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <path class="cls-2" d="m39.53,73c-4.12,0-8.19-.87-11.81-2.51-11.76,4.82-18.72,1.23-19.01,1.07-.76-.4-1.19-1.23-1.1-2.08.09-.85.69-1.56,1.52-1.8,5.31-1.5,7.23-4.85,7.85-6.43-1.99-3.22-3.03-6.84-3.03-10.54,0-12.29,11.48-22.29,25.59-22.29,3.42,0,6.73.58,9.86,1.71,1.09.4,1.65,1.6,1.26,2.69-.4,1.09-1.6,1.65-2.69,1.26-2.66-.97-5.5-1.46-8.42-1.46-11.79,0-21.39,8.11-21.39,18.09,0,3.18.99,6.31,2.87,9.04.34.49.45,1.1.31,1.67-.22.92-1.27,4.5-5.05,7.38,2.66-.03,6.24-.62,10.65-2.55.57-.25,1.22-.23,1.78.05,3.26,1.63,7.01,2.49,10.82,2.49,11.79,0,21.38-8.11,21.38-18.08,0-1.16.94-2.1,2.1-2.1s2.1.94,2.1,2.1c0,12.29-11.48,22.28-25.58,22.28Z"/>
  <path class="cls-3" d="m82.41,39.24l-.46-6.73-5.7-.79-4.11-6.16.98-6.1-6-2.45-4.22,4.9h-6.84l-4.49-3.87-5.88,3.87,1.93,6.05-2.96,6.38-5.13,2.17v6.73l6.16,1.25,3.87,5.36-.91,6.05,6.62,2.74,3.19-4.33,7.41-.91,4.56,4.22,5.7-3.54-1.98-6.16,2.43-6.5,5.81-2.17Zm-21.43,9.55c-6.06,0-10.98-4.91-10.98-10.98s4.92-10.98,10.98-10.98,10.98,4.91,10.98,10.98-4.92,10.98-10.98,10.98Z"/>
  <g>
    <path class="cls-2" d="m37.9,48.93c-.22-.38-.1-.87.28-1.1.38-.23.88-.1,1.11.28l6.49,10.84h0c.22.39.1.88-.28,1.11-.38.23-.88.1-1.11-.28l-6.49-10.84h0Z"/>
    <g>
      <circle class="cls-1" cx="45.09" cy="59.37" r="1.84"/>
      <path class="cls-3" d="m42.92,60.63c-.09-.15-.16-.31-.21-.47-.21-.64-.16-1.32.14-1.92s.82-1.05,1.45-1.26,1.32-.16,1.92.14c1.24.62,1.74,2.13,1.12,3.37-.3.6-.82,1.05-1.45,1.26s-1.32.16-1.92-.14c-.44-.22-.8-.56-1.04-.98Zm3.18-1.85c-.11-.19-.27-.35-.49-.46-.28-.14-.59-.16-.89-.06-.3.1-.54.31-.68.58-.14.28-.16.59-.06.89.1.3.31.54.58.68.28.14.59.16.89.06.3-.1.54-.31.68-.58.18-.36.16-.78-.03-1.11Z"/>
    </g>
    <path class="cls-2" d="m25.44,50.48c-.05-.09-.09-.19-.1-.3-.06-.44.26-.85.7-.9l12.53-1.6c.44-.06.84.26.9.7.06.44-.26.85-.7.9l-12.53,1.6c-.33.04-.64-.12-.8-.4Z"/>
    <g>
      <circle class="cls-1" cx="26.09" cy="50.09" r="1.84"/>
      <path class="cls-3" d="m23.91,51.34c-.16-.28-.27-.6-.32-.94-.08-.67.09-1.32.51-1.85.41-.53,1-.87,1.67-.95.67-.08,1.32.09,1.85.51.53.41.87,1,.95,1.67h0c.17,1.37-.8,2.63-2.17,2.81-1.03.13-2-.39-2.49-1.23Zm3.18-1.84c-.07-.13-.17-.24-.3-.34-.25-.19-.55-.27-.86-.23s-.58.2-.78.44-.27.55-.23.86c.04.31.2.58.44.78.25.19.55.27.86.24.64-.08,1.09-.67,1.01-1.3h0c-.02-.16-.07-.31-.15-.44Z"/>
    </g>
    <g>
      <circle class="cls-1" cx="38.67" cy="48.49" r="1.84"/>
      <path class="cls-3" d="m36.5,49.74c-.16-.28-.27-.6-.32-.94-.17-1.37.8-2.63,2.17-2.81s2.63.8,2.81,2.17c.17,1.37-.8,2.63-2.17,2.81-1.03.13-2-.39-2.49-1.23Zm3.18-1.84c-.07-.13-.17-.24-.3-.34-.25-.19-.55-.27-.86-.24-.31.04-.58.2-.78.44-.19.25-.27.55-.24.86.04.31.2.58.44.78.25.19.55.27.86.24.31-.04.58-.2.78-.44.19-.25.27-.55.24-.86-.02-.16-.07-.31-.15-.44Z"/>
    </g>
  </g>
</svg>
</template>

<script>
export default {
    name: "CustomerPerformanceBySegmentIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #59c5c7;
  }
  .cls-3 {
    fill: #116577;
  }
</style>